import React from "react";
import { useAppTranslation } from "../../../../../../../i18n/useAppTranslation";
import { EntityHeader } from "../../../../../../../widgets/EntityHeader/EntityHeader";
import { Button } from "../../../../../../../shared/Button/Button";
import { history } from "../../../../../../../history";
import { SETTINGS_ROUTES } from "../../../../../../../consts/routes";

/**
 * @param {{
 *    searchFilter: {
 *      value: string;
 *      onChange: (value: string) => void;
 *    };
 * }} param0
 */
export const Header = ({ searchFilter }) => {
  const { tSettings: t } = useAppTranslation.Settings({
    keyPrefix: "smsSnippets.all",
  });

  return (
    <EntityHeader
      title={t("title")}
      searchValue={searchFilter.value}
      onChangeSearch={searchFilter.onChange}
      right={
        <Button
          size="small"
          onClick={() => history.push(SETTINGS_ROUTES.smsSnippets.create())}
        >
          {t("add")}
        </Button>
      }
    />
  );
};
